import axiosInstance from "../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";

const getToken = () => {
    return localStorage.getItem("token");
};

export const GetDepartments = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetDepartments`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetDesignations = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetDesignations`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetIdentityTypes = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetIdentityTypes`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetEmployeeTypes = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetEmployeeTypes`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const GetKPICategories = async () => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetKPICategories`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};


export const GetEmployees = async (filters) => {
    const { ZoneId, CircleId, IsActive } = filters;
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/MasterDetails/GetEmployees?ZoneId=${ZoneId}&CircleId=${CircleId}&IsActive=${IsActive}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const AddNewEmployee = async (responseData) => {
    try {
        const response = await axiosInstance.post(`${API_BASE_URL1}GMAM/MasterCreate/AddNewEmployee`, responseData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const EditEmployeeDetails = async (responseData) => {
    try {
        const response = await axiosInstance.put(`${API_BASE_URL1}GMAM/MasterCreate/UpdateEmployeeDetails`, responseData,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "multipart/form-data",
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};


export const getDesignations = async (OperationId, IsActive) => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetDesignations?OperationId=${OperationId}&IsActive=${IsActive}`,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                }
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

export const addDesignation = async (values) => {
    try {
        const response = await axiosInstance.post(`${API_BASE_URL1}GMAM/Attendance/AddNewDesignation`, values,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};


export const updateDesignation = async (values) => {
    try {
        const response = await axiosInstance.put(`${API_BASE_URL1}GMAM/Attendance/UpdateDesignationDetails`, values,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                }
            }
        );
        return response;
    } catch (error) {
        return error;
    }
};

export const GetOperations = async (IsActive = "") => {
    try {
        const response = await axiosInstance.get(`${API_BASE_URL1}GMAM/Attendance/GetOperations?IsActive=${IsActive}`, {
            headers: {
                Authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching operations:', error);
        return error;
    }
};
// API call to add a new operation (POST request)
export const AddOperationDetails = async (data) => {
    try {
        const response = await axiosInstance.post(
            `${API_BASE_URL1}GMAM/Attendance/AddNewOperation`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.error('Error adding operation:', error);
        return error;
    }
};
// API call to update an operation (PUT request)
export const UpdateOperationDetails = async (data) => {
    try {
        const response = await axiosInstance.put(
            `${API_BASE_URL1}GMAM/Attendance/UpdateOperationDetails`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${getToken()}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error updating operation:", error);
        return error;
    }
};